// Exported so callers (e.g. spendingTrend/series.ts) can detect "the shared default" to rescale from.
export const CORNER_RADIUS = 4;

export const TOP_RADIUS: [number, number, number, number] = [CORNER_RADIUS, CORNER_RADIUS, 0, 0];
export const BOTTOM_RADIUS: [number, number, number, number] = [0, 0, CORNER_RADIUS, CORNER_RADIUS];
export const BOTH_RADIUS: [number, number, number, number] = [
  CORNER_RADIUS,
  CORNER_RADIUS,
  CORNER_RADIUS,
  CORNER_RADIUS,
];

export const NO_RADIUS: [number, number, number, number] = [0, 0, 0, 0];

export const cornerRadiusFor = (value: number): [number, number, number, number] =>
  value < 0 ? BOTTOM_RADIUS : TOP_RADIUS;

/**
 * Corner radius for one segment of a stacked bar: rounds the segment's tip only when that tip is the
 * outer edge of the whole stack, so segments meet flush where they join.
 *
 * ECharts stacks same-sign values only, so two series on opposite sides of zero each keep their own
 * tip exposed. When they share a sign the later series stacks beyond the earlier one and takes the
 * edge, leaving the earlier tip as an internal seam that must not be rounded.
 *
 * @param value the value this segment plots
 * @param stackedAfter value of the segment stacked after this one (0 when it is last)
 */
export const stackedCornerRadiusFor = (value: number, stackedAfter = 0): [number, number, number, number] => {
  const ownsOuterEdge = value >= 0 ? stackedAfter <= 0 : stackedAfter >= 0;
  return ownsOuterEdge ? cornerRadiusFor(value) : NO_RADIUS;
};

// Horizontal bars: rounded on the bar's tip — right corners for positive
// (grows right), left corners for negative (grows left).
export const RIGHT_RADIUS: [number, number, number, number] = [0, CORNER_RADIUS, CORNER_RADIUS, 0];
export const LEFT_RADIUS: [number, number, number, number] = [CORNER_RADIUS, 0, 0, CORNER_RADIUS];

export const horizontalCornerRadiusFor = (value: number): [number, number, number, number] =>
  value < 0 ? LEFT_RADIUS : RIGHT_RADIUS;
